import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import AppWrapper from './App'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from "@vercel/speed-insights/react"
import * as Sentry from "@sentry/react"
import ErrorBoundary from './context/ErrorBoundary'
import { AuthProvider } from './context/auth'
import { AdminAuthProvider } from './context/adminAuth'

// Initialize Sentry
Sentry.init({
  dsn: "https://fc40cfec39e772807149881c3748c291@o4508970519560192.ingest.us.sentry.io/4508970525327360",
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    "falashop.com",
    /^https:\/\/[^/]*\.falashop\.com/,
    "falashop.com",
    /^https:\/\/[^/]*\.falashop\.com/,
  ],
  debug: process.env.NODE_ENV === 'development',
});

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AdminAuthProvider>
          <Router>
            <ErrorBoundary>
              <HelmetProvider>
                <AppWrapper />
                <Analytics />
                <SpeedInsights />
              </HelmetProvider>
            </ErrorBoundary>
          </Router>
        </AdminAuthProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)

